import { Pipe, PipeTransform } from '@angular/core';
import { SalesPerformanceFacetItemWithFlag } from '../../store/reporting/types';

@Pipe({
  name: 'totalCountPipe',
})
export class TotalCountPipe implements PipeTransform {
  transform(items: SalesPerformanceFacetItemWithFlag[]): number {
    if (!items) return 0;
    if (items.length === 0) return 0;

    return items.reduce((sum, item) => sum + item.count, 0);
  }
}
